// extracted by mini-css-extract-plugin
export default {"impressumContainer":"Impressum_impressumContainer__5z+43","header":"Impressum_header__gFUMf"};